import {type CSSProperties, memo, useMemo} from 'react'
import {Spinner} from '@gwc/main'
import {Box} from '../box'
import * as styles from './FullscreenOverlayWithSpinner.classes'

/** Пропсы компонента FullscreenOverlayWithSpinner */
type FullscreenOverlayWithSpinnerProps = {
  /**
   * z-index оверлея
   * @default 99999
   */
  zIndex?: CSSProperties['zIndex']
}

/**
 * Оверлей на всю ширину и высоту экрана со спиннером посередине.
 */
export const FullscreenOverlayWithSpinner = memo<FullscreenOverlayWithSpinnerProps>(
  function FullscreenOverlayWithSpinner({zIndex = 99999}) {
    const overlayStyle = useMemo(() => ({zIndex}), [zIndex])

    return (
      <Box alignItems="center" className={styles.overlay} justifyContent="center" style={overlayStyle}>
        <Spinner size="m" />
      </Box>
    )
  },
)
